module.exports = __webpack_public_path__ + "static/img/newsPic3.094b9f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsPic3.png
// module id = GKZ8
// module chunks = 1